import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitCamelCase'
})
export class SplitCamelCasePipe implements PipeTransform {

  transform(value?: string): string | undefined {
    let p: string | undefined = value?.replace(/([a-z])([A-Z])/g, '$1 $2');
    p = p?.replace(/([a-zA-Z])([0-9])([a-zA-Z])/g, '$1 $2 $3');
    p = p?.replace(/\b\w/g, l => l.toUpperCase());
    return p;
  }

}
